import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/internal/Subscription';
import { config } from 'src/app/configs/config';
import { Store } from 'src/app/core/store/store';
import { Content, Course, Module } from 'src/app/shared/models/course.model';
import { User, VisitedCourse } from 'src/app/shared/models/user.model';
import { CourseService } from 'src/app/shared/services/course.service';
import { PlayerUtilityService } from '../../../services/player-utility.service';
import * as screenfull from 'screenfull';
import { distinctUntilChanged, distinctUntilKeyChanged, filter, take } from 'rxjs/operators';

@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.css']
})
export class ContentComponent implements OnInit {
  modules: Module[] = [];
  lastVisitedContentId: string;
  currentId: string;
  completedContents: string[];
  // currentCourse: VisitedCourse;
  currentCourse: any;
  moduleSetting = {};
  _moduleOverview = {
    show: false,
    moduleNumber: 0,
    moduleName: ''
  }
  @Output() openModuleOverview = new EventEmitter<any>();
  @Output() hideWalkthrough = new EventEmitter();
  @Output() hideCourseProgress = new EventEmitter();
  user: User;
  course: Course;
  dataCourseLoader: any = false;
  @Input() courseId: string;
  @Input() set moduleOverview(value) {
    this._moduleOverview = value;
  }
  scrollbarOptions = {
    live: true
  }
  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  @Output() sideBarClicked: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  private subscription: Subscription;
  private userSubscription: Subscription;

  constructor(private route: ActivatedRoute, private store: Store, private courseService: CourseService, private playerUtilityService: PlayerUtilityService) {

  }

  onClose() {
    this.close.emit(true);
  }
  ngOnInit() {
    if (this.courseId) {
      this.subscription = this.store.select<Course>(`course`).pipe(filter((x: any) => x), take(1)).subscribe(course => {
        if (course) {
          this.course = course
          if (course['moduleSetting']) {
            course['moduleSetting'].forEach(ms => {
              this.moduleSetting[ms.moduleNumber] = ms.showModuleWalkThrough;
            });
          }
          this.modules = [];
          for (let cont of course.contents) {
            let i = this.modules.findIndex(g => g.moduleNumber == cont.moduleNumber);
            cont.contentInfo['isForTrail'] = cont.isForTrail;
            (i >= 0 && this.modules[i].contents.push(cont.contentInfo)) || this.modules.push({ moduleName: cont.moduleName, moduleNumber: cont.moduleNumber, contents: [cont.contentInfo] })
          }
          this.modules = this.modules.sort((a, b) => a.moduleNumber - b.moduleNumber);
          this.subscription && this.subscription.unsubscribe()
          this.subscription = null;
        }
      });
      this.userSubscription = this.store.select<User>('user').subscribe(
        user => {
          if (user) {
            this.user = user;
            // let currentCourse = this.store.value['currentUserCourse'];
            // let currentCourse = user.visitedCourses.find(vc => vc.id == this.courseId);
            /* if (currentCourse) {
              this.lastVisitedContentId = currentCourse.lastVisitedContent;
              this.currentId = this.lastVisitedContentId;
              this.completedContents = currentCourse.contentsCompleted;
              this.currentCourse = currentCourse;
            } */
          }
        }
      );

      this.store.select('currentUserCourse').subscribe((currentUserCourse: any) => {
        // let currentCourse = this.store.value['currentUserCourse'];
        // let currentCourse;
        if(currentUserCourse) {
          // currentCourse = currentUserCourse;
          // if (currentCourse) {
            this.lastVisitedContentId = currentUserCourse.lastVisitedContent;
            this.currentId = this.lastVisitedContentId;
            this.completedContents = currentUserCourse.contentsCompleted;
            this.currentCourse = currentUserCourse;
          // }
        }
      })

      this.courseService.currentPlayedItem$.subscribe(item => {
        if (item) {
          this.currentId = item;
        }
        else {
          this.currentId = null;
        }
      })
    }
    // Play video from notes saved
    this.playerUtilityService.videoNotes$.subscribe(notesData => {
      let objModule = this.modules.find(el => el.moduleNumber == notesData.moduleNumber);
      let objContent = objModule.contents.find(el => el._id == notesData.content);
      objContent['recordedTime'] = notesData.recordedTime;
      this.play(objContent);
    });
  }

  play(content: Content) {
    if (screenfull.enabled && screenfull.isFullscreen) {
      screenfull.exit();
    }
    if (this.courseService.currentItem === content._id) {
      this.hideWalkthrough.emit();
      this.hideCourseProgress.emit();
      return;
    }
    this.courseService.setcurrentPlayedItem(content._id);
    this.sideBarClicked.emit(true);
    this.hideWalkthrough.emit();
    this.hideCourseProgress.emit();

  }

  hasScore(id) {
    let item = this.currentCourse.exercises.find(el => el.id == id);
    if (!item) return true;
    if (item && item.status == 'PUBLISHED')
      return true;
    return false;
  }

  showModule(module: Module) {
    return module.contents.map(c => c._id).indexOf(this.lastVisitedContentId) > -1
  }

  showModuleOverview(mod) {
    if (mod.contents[0]) {
      this.courseService.setcurrentPlayedItem(mod.contents[0]._id);
    }
    this.openModuleOverview.emit({ moduleNumber: mod.moduleNumber, moduleName: mod.moduleName });
  }

  ngOnDestroy() {
    this.subscription && this.subscription.unsubscribe();
    this.userSubscription && this.userSubscription.unsubscribe();
  }

  contentLocked(isForTrial, type?) {
    if (this.course.courseTypeVersion == 2 && type == 'SUMMIT' && this.currentCourse.progress < 95)
      return true;
    // if (!isForTrial && this.user && config.B2C_ORGANIZATIONS.includes(this.user.organization) && !this.alreadyPurchasedCourse()) {
    //   return true;
    // }
    return false;
  }


  alreadyPurchasedCourse() {
    if (this.currentCourse.trait == 'Embracing Change')
      return true;
    if (this.user.purchasedCourses && this.user.purchasedCourses.length) {
      let i = this.user.purchasedCourses.findIndex(el => el.id == this.courseId);
      return i > -1;
    }
    return false;
  }

  isModuleCompleted({ contents }: Module) {
    if (this.currentCourse && (this.currentCourse.progress == 100)) return true;
    if (contents.length) {
      return contents.every(ct => this.completedContents && this.completedContents.includes(ct._id));
    }
    return false;
  }
}
